import { signal } from 'services/SignalsService'
import { tweenSequence } from 'settings/tweenSequence'
import { moveIn } from 'utils/Tweens'

export default class FreespinsStartEntity extends PIXI.Container {
  constructor() {
    super()

    signal.on('STATE:IN:FS-START', () => {
      const startButton = this.getChildByName('startFreespin') || this.getChildByName('start')
      if(startButton && startButton._data.tween){
        moveIn(startButton, {
          startX: startButton.x,
          startY: 1400,
          endX: startButton.x,
          endY: startButton.y,
          ...tweenSequence.startFreeSpinButtonAppears,
        })
      }
    })
  }
}
